<template>
    <div id="apply_info" class="apply_info">
        <strong class="tit_apply">{{ title }}</strong>
        <span class="txt_schedule">
            <span class="ico_cafe ico_calendar">기간</span><span id="apply_due">{{ due }}</span>
        </span>
        <div id="detail_apply" class="detail_apply" v-show="isOpenDetail">
            <pre id="desc_apply">{{ desc }}</pre>
            <div class="wrap_list">
                <ul id="list_thumb" class="list_thumb" :class="{ list_thumb_type1: images.length === 1, list_thumb_type2: images.length !== 1 }" :style="ulTagWidth">
                    <li class="info_image #noti_image_viewer" :style="imageStyle(image, thumbnailSize.width, thumbnailSize.height)" v-for="(image, index) in images" :key="index" @click="goImageUrl(image)"></li>
                </ul>
            </div>
        </div>
        <button type="button" class="btn_apply" id="btn_noti_fold" @click="toggleDetail">
            <span class="noti_fold_title">{{ buttonMessage }}</span><span class="ico_cafe" :class="{ ico_open: !isOpenDetail }"></span>
        </button>
    </div>    
</template>

<script>
export default {
    props: {
        type: String,
        title: String,
        due: String,
        desc: String,

        images: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    data() {
        return {
            isOpenDetail: true
        };
    },
    computed: {
        buttonMessage() {
            return this.isOpenDetail ? "공지글 접기" : "공지글 보기";
        },
        thumbnailSize() {
            return this.images.length > 1 ? { width: 336, height: 336 } : { width: 640, height: 0 };
        },
        ulTagWidth() {
            const n = this.images.length;
            if(n === 0 || n === 1) return "";
            return `width: ${n * 171}px;`;
        }
    },
    methods: {
        toggleDetail() {
            this.isOpenDetail = !this.isOpenDetail;
        },
        imageStyle(url, width, height) {
            const thumbnailImageUrl = this.getThumbnail(url, `C${width}x${height}`);
            return {
                backgroundSize: "cover",
                backgroundImage: `url(${thumbnailImageUrl})`
            }
        },
        goImageUrl(url) {
            window.location.href = url;
        },
        getThumbnail(imageUrl, thumbSize) {
            if (imageUrl.indexOf('?fname=') > 0) return imageUrl;
            const host = /sandbox\.kakaocdn\.net/.test(imageUrl) ? "img1-sandbox.kakaocdn.net" : "img1.daumcdn.net";
            return `https://${host}/thumb/${thumbSize}/?fname=${encodeURIComponent(imageUrl)}`;
        }
    }
}
</script>
